import { useCoreConfig } from '#imports'

export type UseSiteUrlReturn = (path: string) => string | undefined

/**
 * Builds absolute URLs on the brand's public origin (`core.site.url`) for canonicals,
 * `og:*` tags and JSON-LD. Returns `undefined` when the brand has no `site.url`.
 */
export const useSiteUrl = (): UseSiteUrlReturn => {
    const { site } = useCoreConfig()

    return path => site.url ? `${site.url}${path}` : undefined
}
